export default __webpack_public_path__ + "static/media/step1.6ac94458.gif";